module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/carousel_tiktok_tablet_09@2x-65d26e9931bebeecea2f09e5872396b3.jpg";